export default {
  panels: [
    {
      index: 0,
      height: 190,
      width: 80,
      // paperHeader: 49.5,
      // paperFooter: 780,
      printElements: [
        {
            "options": {
                "left": 0,
                "top": 0,
                "height": 535.5,
                "width": 226.5,
                "borderWidth": "3",
                "right": 226.5,
                "bottom": 535.5,
                "vCenter": 113.25,
                "hCenter": 267.75
            },
            "printElementType": {
                "title": "矩形",
                "type": "rect"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 3,
                "height": 40,
                "width": 223.5,
                "testData": "常规标题",
                "fontSize": 16,
                "fontWeight": "700",
                "textAlign": "center",
                "textContentVerticalAlign": "middle",
                "hideTitle": true,
                "title": "连云港供电公司物资卡片",
                "right": 120,
                "bottom": 20.75,
                "vCenter": 60,
                "hCenter": 10.75,
                "coordinateSync": false,
                "widthHeightSync": false,
                "qrCodeLevel": 0
            },
            "printElementType": {
                "title": "常规标题",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 43.5,
                "height": 9,
                "width": 222,
                "borderWidth": "3",
                "right": 225.75,
                "bottom": 53.25,
                "vCenter": 114.75,
                "hCenter": 48.75
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 72,
                "top": 45,
                "height": 321,
                "width": 9,
                "borderWidth": "3",
                "right": 81.75,
                "bottom": 365.25,
                "vCenter": 77.25,
                "hCenter": 204.75
            },
            "printElementType": {
                "title": "竖线",
                "type": "vline"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 43.5,
                "height": 40,
                "width": 69,
                "testData": "常规标题",
                "fontSize": 16,
                "fontWeight": "700",
                "textAlign": "center",
                "textContentVerticalAlign": "middle",
                "hideTitle": true,
                "title": "物料编码",
                "right": 74.25,
                "bottom": 86.5,
                "vCenter": 39.75,
                "hCenter": 66.5,
                "coordinateSync": false,
                "widthHeightSync": false,
                "qrCodeLevel": 0
            },
            "printElementType": {
                "title": "常规标题",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 82.5,
                "height": 40,
                "width": 69,
                "testData": "常规标题",
                "fontSize": 16,
                "fontWeight": "700",
                "textAlign": "center",
                "textContentVerticalAlign": "middle",
                "hideTitle": true,
                "title": "计量单位",
                "right": 75,
                "bottom": 104.75,
                "vCenter": 40.5,
                "hCenter": 94.75,
                "coordinateSync": false,
                "widthHeightSync": false,
                "qrCodeLevel": 0
            },
            "printElementType": {
                "title": "常规标题",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 82.5,
                "height": 9,
                "width": 222,
                "borderWidth": "3",
                "right": 242.25,
                "bottom": 104.25,
                "vCenter": 131.25,
                "hCenter": 99.75
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 121.5,
                "height": 40,
                "width": 69,
                "testData": "常规标题",
                "fontSize": 16,
                "fontWeight": "700",
                "textAlign": "center",
                "textContentVerticalAlign": "middle",
                "hideTitle": true,
                "title": "批次号",
                "right": 71.25,
                "bottom": 161.5,
                "vCenter": 36.75,
                "hCenter": 141.5,
                "coordinateSync": false,
                "widthHeightSync": false,
                "qrCodeLevel": 0
            },
            "printElementType": {
                "title": "常规标题",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 0,
                "top": 121.5,
                "height": 9,
                "width": 222,
                "borderWidth": "3",
                "right": 224.25,
                "bottom": 102.75,
                "vCenter": 113.25,
                "hCenter": 98.25
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 160.5,
                "height": 9,
                "width": 222,
                "borderWidth": "3",
                "right": 236.25,
                "bottom": 238.5,
                "vCenter": 125.25,
                "hCenter": 234
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 160.5,
                "height": 40,
                "width": 69,
                "testData": "常规标题",
                "fontSize": 16,
                "fontWeight": "700",
                "textAlign": "center",
                "textContentVerticalAlign": "middle",
                "hideTitle": true,
                "title": "物料描述",
                "right": 72.99609375,
                "bottom": 202.99609375,
                "vCenter": 38.49609375,
                "hCenter": 182.99609375,
                "coordinateSync": false,
                "widthHeightSync": false,
                "qrCodeLevel": 0
            },
            "printElementType": {
                "title": "常规标题",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 201,
                "height": 40,
                "width": 69,
                "testData": "常规标题",
                "fontSize": 16,
                "fontWeight": "700",
                "textAlign": "center",
                "textContentVerticalAlign": "middle",
                "hideTitle": true,
                "title": "供应商",
                "right": 68.49609375,
                "bottom": 241.24609375,
                "vCenter": 33.99609375,
                "hCenter": 221.24609375,
                "coordinateSync": false,
                "widthHeightSync": false,
                "qrCodeLevel": 0
            },
            "printElementType": {
                "title": "常规标题",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 201,
                "height": 9,
                "width": 222,
                "borderWidth": "3",
                "right": 240,
                "bottom": 208.5,
                "vCenter": 129,
                "hCenter": 204
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 241.5,
                "height": 9,
                "width": 222,
                "borderWidth": "3",
                "right": 230.25,
                "bottom": 249.75,
                "vCenter": 119.25,
                "hCenter": 245.25
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 243,
                "height": 40,
                "width": 69,
                "testData": "常规标题",
                "fontSize": 16,
                "fontWeight": "700",
                "textAlign": "center",
                "textContentVerticalAlign": "middle",
                "hideTitle": true,
                "title": "日期",
                "right": 72.24609375,
                "bottom": 282.49609375,
                "vCenter": 37.74609375,
                "hCenter": 262.49609375,
                "coordinateSync": false,
                "widthHeightSync": false,
                "qrCodeLevel": 0
            },
            "printElementType": {
                "title": "常规标题",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 282,
                "height": 9,
                "width": 222,
                "borderWidth": "3",
                "right": 227.49609375,
                "bottom": 290.49609375,
                "vCenter": 116.49609375,
                "hCenter": 285.99609375
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 285,
                "height": 40,
                "width": 69,
                "testData": "常规标题",
                "fontSize": 16,
                "fontWeight": "700",
                "textAlign": "center",
                "textContentVerticalAlign": "middle",
                "hideTitle": true,
                "title": "物资数量",
                "right": 69.99609375,
                "bottom": 325.24609375,
                "vCenter": 35.49609375,
                "hCenter": 305.24609375,
                "coordinateSync": false,
                "widthHeightSync": false,
                "qrCodeLevel": 0
            },
            "printElementType": {
                "title": "常规标题",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 325.5,
                "height": 40,
                "width": 69,
                "testData": "常规标题",
                "fontSize": 16,
                "fontWeight": "700",
                "textAlign": "center",
                "textContentVerticalAlign": "middle",
                "hideTitle": true,
                "title": "备注",
                "right": 71.49609375,
                "bottom": 367.24609375,
                "vCenter": 36.99609375,
                "hCenter": 347.24609375,
                "coordinateSync": false,
                "widthHeightSync": false,
                "qrCodeLevel": 0
            },
            "printElementType": {
                "title": "常规标题",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 0,
                "top": 325.5,
                "height": 9,
                "width": 222,
                "borderWidth": "3",
                "right": 211.74609375,
                "bottom": 333.99609375,
                "vCenter": 100.74609375,
                "hCenter": 329.49609375
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 3,
                "top": 366,
                "height": 9,
                "width": 222,
                "borderWidth": "3",
                "right": 228,
                "bottom": 373.5,
                "vCenter": 117,
                "hCenter": 369,
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 45,
                "top": 375,
                "height": 70.5,
                "width": 135,
                "field": "qrcode",
                "testData": "mh1234567890",
                "fontSize": 12,
                "lineHeight": 18,
                "textType": "qrcode",
                "title": "二维码",
                "right": 171,
                "bottom": 449.25,
                "vCenter": 103.5,
                "hCenter": 414
            },
            "printElementType": {
                "title": "二维码",
                "type": "text"
            }
        },
        {
            "options": {
                "left": 1.5,
                "top": 450,
                "height": 9,
                "width": 222,
                "borderWidth": "3"
            },
            "printElementType": {
                "title": "横线",
                "type": "hline"
            }
        },
        {
            "options": {
                "left": 49.5,
                "top": 477,
                "height": 32,
                "width": 120,
                "field": "barcode",
                "testData": "mh1234567890",
                "fontSize": 12,
                "lineHeight": 18,
                "textAlign": "left",
                "textType": "barcode",
                "title": "条形码"
            },
            "printElementType": {
                "title": "条形码",
                "type": "text"
            }
        }
    ],
      paperNumberLeft: 565.5,
      paperNumberTop: 819,
      // paperNumberDisabled:true,
      paperNumberFormat:' ',
    },
  ],
};
